import { InstanceClone } from '../types';
import { clone } from './clone';

export function cloneArrayDeep<T>(
  value: T,
  instanceClone?: InstanceClone<T>,
): T {
  const length = (value as unknown[]).length;
  const cloned = new (value as any).constructor(length) as unknown[];

  for (let i = 0; i < length; i++) {
    const valueI = (value as any)[i];
    cloned[i] = clone(valueI, instanceClone);
  }
  return cloned as T;
}

export const asssync = async () => Promise.resolve(5);
